import config from './config';

requirejs(['jquery'], function($) {
    const apiBaseUrl = config.apiUrl + '/v1/';

    $('table[chart-table]').each(function(){
        const table = $(this);
        const body = table.find('tbody');
        const type = table.attr('data-type');
        const codes = table.attr('data-codes');
        const rowTemplate = `<tr data-url="{{url}}" class="chart-table__row">
            <td class="chart-table__cell"><span class="chart-table__item-name">{{name}}</span></td>
            <td class="chart-table__cell">{{value}}</td>
            <td class="chart-table__cell chart-table__cell--change">{{change}}</td>
            <td class="chart-table__cell">{{updatedAt}}</td>
            <td class="chart-table__cell"><i class="fa fa-chevron-right" aria-hidden="true"></i></td>
        </tr>`;

        table.on('click', '[data-url]', function(){
            const url = $(this).attr('data-url');
            window.location = url;
            // window.location = url + '?test_login=kbuczek';
        });

        let urlBase = '';
        let endpoint = '';

        if ('nbp' === type) {
            urlBase = '/finanse/notowania/kursy-nbp-srednie/';
            endpoint = 'nbp-currencies';
        } else if ('forex' === type) {
            urlBase = '/finanse/notowania/forex/';
            endpoint = 'forex';
        } else if ('gpw_index' === type) {
            urlBase = '/finanse/notowania/indeksy/';
            endpoint = 'gpw-indexes';
        } else if ('gpw_action' === type) {
            urlBase = '/finanse/notowania/spolki/';
            endpoint = 'gpw-actions';
        } else if ('commodity' === type) {
            urlBase = '/finanse/notowania/surowce/';
            endpoint = 'commodities';
        }

        if (codes) {
            endpoint += '?codes=' + codes;
        }

        const url = apiBaseUrl + endpoint;
        $.get(url, function(response) {
            const items = response.data;
            body.hide();

            items.forEach((item) => {
                let change = item.change > 0 ?
                    '<span class="chart-table__change chart-table__change--positive">' + item.change + '%</span>' :
                    '<span class="chart-table__change chart-table__change--negative">' + item.change + '%</span>' ;

            let value = 0;
            let codeOrName = item.code
            let formatDate = item.updated_at

            if ('forex' === type) {
                value = item.mid;
            } else if ('commodity' === type) {
                value = item.closing;
                codeOrName = item.name;
            } else {
                value = item.value;
            }

            const row = rowTemplate.replace('{{name}}', codeOrName).replace('{{value}}', value).replace('{{change}}', change).replace('{{updatedAt}}', formatDate).replace('{{url}}', urlBase + item.code);

                body.append(row);
            });

            body.fadeIn('slow');
        });
    });
});


// WEBPACK FOOTER //
// ./js/tables.js